import { useState } from "react";

const check = (data, status, initial) => {
  if (status) {
    return data;
  } else {
    return initial;
  }
};

const useInput = ({ data = "", status = false, initial = "" }) => {
  const [value, setValue] = useState(check(data, status, initial));
  return [
    {
      value,
      onChange: (e) => setValue(e.target.value),
      saveValue: (val) => setValue(val),
      onWheel: (event) => event.currentTarget.blur(),
    },
    () => setValue(check(initialValue)),
  ];
};

export default useInput;
